import React from "react";
import "../styling/Contact.css";
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Contact = () => {
  return (
    <div className="contact-container">
      <h1>Contact Us</h1>

      {/* Notice for clients */}
      <div className="note">
        <strong>Note for Existing Clients:</strong><br />
        If you already have an account with VOETA, please log in to our{" "}
        <strong>mobile app</strong> and use the <strong>in-app chat</strong> to
        contact our support team directly.
      </div>

      {/* Location disclaimer */}
      <div className="note">
        We may operate from multiple locations within each country, but we list
        here only the <strong>main office</strong> or{" "}
        <strong>central contact point</strong> in each country.
      </div>

      {/* Location 1 */}
      <div className="location">
        <h2>Head Office – Los Angeles, CA, USA</h2>
        <div className="contact-info">
          <p>
            <FaEnvelope /> info@voeta.co
          </p>
          <p>
            <FaPhone /> +1 (562) 577-4944
          </p>
          <p>
            <FaMapMarkerAlt /> 601 S Figueroa St, Los Angeles, CA 90017, United
            States
          </p>
        </div>
      </div>

    </div>
  );
};

export default Contact;
